/**
 * Created by guntherclaes on 04/03/2017.
 */

var vskoButton = angular.module('vskoButton', []);
vskoButton.directive('vskoButton', [function() {
  var SIZES = [{id: 'xsmall', css: 'xs'}, {id: 'small', css: 'sm'}, {id: 'large', css: 'lg'}];

  return {
    restrict: 'E',
    template: require('./vsko-button.html'),
    replace: true,
    transclude: true,
    scope: {
      type: '@',
      size: '@',
      hover: '=',
      loading: '=',
      loadingText: '@',
      active: '='
    },
    link: function ($scope, element, attrs) {
      'use strict';

      $scope.getStyleClass = function() {
        var styles = [];

        var type = "btn-" + ($scope.type || "default");
        if ($scope.hover) {
           type += "-hover";
        }
        styles.push(type);

        var size = $.grep(SIZES, function(e) { return e.id == $scope.size; });
        if (size.length > 0) {
          styles.push("btn-" + size[0].css || "" );
        }

        if ($scope.loading) {
          styles.push("btn-loading");
        }

        if ($scope.active) {
          styles.push("active");
        }
        return styles.join(" ");
      }
    }
  }
}]);
